export const validationInput = [
  {
    key: "name",
    type: "text"
  }
];
